import { ReadRolesApiResponse } from 'lib-shared-user-role';
import orderBy from 'lodash/orderBy';

/**
 * Transforms the read roles response.
 *
 * @param response The raw response from read roles endpoint.
 */
export function transformReadRolesResponse(
  response: ReadRolesApiResponse,
): ReadRolesApiResponse {
  const {
    data: { roles },
    meta,
  } = response;

  return {
    data: {
      // Sort the roles so system roles are at the end of the list.
      roles: orderBy(roles, ['is_system_role'], ['asc']),
    },
    meta,
  };
}
